module.exports = __webpack_public_path__ + "images/edm_social_instagram_x28.png";


//////////////////
// WEBPACK FOOTER
// ./vively/images/email/edm_social_instagram_x28.png
// module id = 868
// module chunks = 3